/**
 * Přehled modulů zobrazený na veřejné landing page.
 * Drží se aktuální navigace v2 (src/components/layout/navigation.ts) —
 * při přidání modulu do aplikace ho doplň i sem.
 */
import type { IconName } from '../../components/icons/Icon';

export type MarketingGroup = 'prehled' | 'dokumenty' | 'realizace' | 'bozp' | 'obchod';

export interface MarketingDoc {
  icon: IconName;
  name: string;
  desc: string;
  group: MarketingGroup;
}

export const marketingGroups: { id: MarketingGroup; label: string }[] = [
  { id: 'dokumenty', label: 'Stavební dokumenty' },
  { id: 'realizace', label: 'Realizace' },
  { id: 'bozp', label: 'BOZP' },
  { id: 'obchod', label: 'Obchod a kancelář' },
  { id: 'prehled', label: 'Organizace' },
];

export const marketingDocs: MarketingDoc[] = [
  { icon: 'crane', name: 'Moje stavby', desc: 'Údaje o stavbě se propisují do všech dokumentů', group: 'prehled' },
  { icon: 'checkSquare', name: 'Úkoly', desc: 'Zadání s termínem, přiřazení kolegovi e-mailem, odevzdání výstupu', group: 'prehled' },

  { icon: 'key', name: 'Předávací prot. — staveniště', desc: 'Předání a převzetí staveniště', group: 'dokumenty' },
  { icon: 'handshake', name: 'Předávací prot. — dílo', desc: 'Základní i rozšířená verze předání díla', group: 'dokumenty' },
  { icon: 'list', name: 'Soupis prací', desc: 'Položkový soupis prací a dodávek s DPH', group: 'dokumenty' },
  { icon: 'clipboardCheck', name: 'Zjišťovací protokol', desc: 'Soupis provedených prací pro fakturaci', group: 'dokumenty' },
  { icon: 'receipt', name: 'Faktura', desc: 'Daňový doklad s QR platbou, podpisem a poznámkami', group: 'dokumenty' },
  { icon: 'tag', name: 'Cenová nabídka', desc: 'Nabídka s položkovým soupisem a DPH', group: 'dokumenty' },
  { icon: 'cart', name: 'Objednávka', desc: 'Objednávka prací či dodávek, kontakty s QR vizitkou', group: 'dokumenty' },
  { icon: 'alertOctagon', name: 'Reklamační protokol', desc: 'Uplatnění reklamace a stanovisko k vadám', group: 'dokumenty' },
  { icon: 'signature', name: 'Podepsat dokument', desc: 'Podpis do PDF, JPG, Wordu i Excelu z knihovny podpisů', group: 'dokumenty' },

  { icon: 'book', name: 'Stavební deník', desc: 'Denní záznamy, počasí, pracovníci, podpisy', group: 'realizace' },
  { icon: 'calendarCheck', name: 'Kontrolní dny', desc: 'Zápisy z KD, sdílení celé stavby nebo jednoho KD', group: 'realizace' },
  { icon: 'blueprint', name: 'Projektová dokumentace', desc: 'Soubory PD se sdílením jednotlivě i hromadně', group: 'realizace' },
  { icon: 'camera', name: 'Fotodokumentace', desc: 'Fotografie průběhu stavby s popisky', group: 'realizace' },
  { icon: 'search', name: 'Vady a nedodělky', desc: 'Evidence a sledování vad a nedodělků', group: 'realizace' },
  { icon: 'help', name: 'Dotazy k projektu', desc: 'Dotazy na projektanta, TDS a investora a jejich vyřízení', group: 'realizace' },
  { icon: 'gantt', name: 'Harmonogram', desc: 'Časový plán prací stavby', group: 'realizace' },
  { icon: 'fileDiff', name: 'Změnové listy', desc: 'Evidence změn oproti smlouvě a projektu', group: 'realizace' },

  { icon: 'phone', name: 'Telefonní čísla', desc: 'Přehled kontaktů stavby, BOZP a IZS', group: 'bozp' },
  { icon: 'medical', name: 'Trauma plán', desc: 'Postup při pracovním úrazu na stavbě', group: 'bozp' },
  { icon: 'usersCheck', name: 'Seznámení BOZP', desc: 'Prezenční listina pro poučení pracovníků', group: 'bozp' },
  { icon: 'bandage', name: 'Kniha úrazů', desc: 'Evidence pracovních úrazů na stavbě', group: 'bozp' },
  { icon: 'warning', name: 'Registr rizik', desc: 'Rizika po činnostech, tisk na šířku', group: 'bozp' },
  { icon: 'flame', name: 'Požární dohled', desc: 'Svařování a otevřený oheň dle vyhl. 87/2000 Sb., záznam kontrol', group: 'bozp' },
  { icon: 'idCard', name: 'Karty zaměstnanců', desc: 'Předaný majetek a OOPP, potvrzení převzetí, hlídání obnovy', group: 'bozp' },

  { icon: 'contacts', name: 'Adresář kontaktů', desc: 'Firmy a subdodavatelé s našeptávačem z ARES', group: 'obchod' },
  { icon: 'folderCheck', name: 'Košilka SoD / objednávky', desc: 'Souhrn ke smlouvě a schvalování přes aplikaci', group: 'obchod' },
  { icon: 'wallet', name: 'Vyúčtování', desc: 'Útraty, převody firemních peněz, kontrola účetní', group: 'obchod' },
  { icon: 'car', name: 'Kniha jízd', desc: 'Evidence jízd služebních vozidel', group: 'obchod' },
  { icon: 'archive', name: 'Archiv dokumentů', desc: 'Uložené dokumenty otevřete, upravíte a znovu vytisknete', group: 'obchod' },
];
